// extracted by mini-css-extract-plugin
export default {"reportLayout":"YdJwL0RHw7cCVBbeoIRH__reportLayout___","section":"XcvkTKhnp65qKwyCo35w__section___"};